import { render, staticRenderFns } from "./SuiteStatistics.vue?vue&type=template&id=47bd69e0&"
import script from "./SuiteStatistics.vue?vue&type=script&lang=js&"
export * from "./SuiteStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports